import { render } from "./WireTransfer.vue?vue&type=template&id=f0fcd25c&scoped=true"
import script from "./WireTransfer.vue?vue&type=script&lang=js"
export * from "./WireTransfer.vue?vue&type=script&lang=js"

import "./WireTransfer.vue?vue&type=style&index=0&id=f0fcd25c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fcd25c"]])

export default __exports__